import { createAri } from '@atlassian/jira-platform-ari';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';

export const useSiteContextARI = () => {
	const cloudId = useCloudId();
	return createAri({ resourceOwner: 'jira', resourceType: 'site', resourceId: cloudId });
};
